import React, { useEffect, useMemo, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuDataTime, NuDate, NuInput, NuInputNew, NuTextArea, NuTime } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import UseEditData from '../../../../Components/Hooks/useEditData';
import * as yup from 'yup';
import Dashboard from '../../../../Components/Icons/Dasboard';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import Delete from '../../../../Components/Icons/Delete';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import axiosInstance from '../../../../Services/axiosCommon';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { TextMediumBase } from '../../../../Components/Text/MediumText';
import EditIcon from '../../../../Components/Icons/Edit';
import Select from 'react-select';
import UseDropDownPR from '../../../../Components/Hooks/UserddNewPr';
import { useQuery } from '@tanstack/react-query';

function EditCustomerQuotes() {

  const location = useLocation();
  const data = location.state?.data;
  const from = location.state?.from;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  let pathFile = location.pathname;
  const { quotesEditId } = useParams();

  // Fetch CQ details to ensure prId is available even when navigating from listing page without prId in state
  const { data: fetchedCqData } = useQuery({
    queryKey: ["CQ-parent-details", quotesEditId],
    queryFn: async () => {
      const res = await axiosInstance.get(`/customer-quotations/${quotesEditId}`);
      return res.data?.data || null;
    },
    enabled: !!quotesEditId,
    refetchOnMount: "always",
    staleTime: 0,
  });

  const [search, setSearch] = useState("");
  const { data: PR, originalData } = UseDropDownPR(`/customer-quotations/PR-drop-down?search=${search}`, search);
  const formik = useFormik
    ({
      enableReinitialize: true,
      initialValues: {
        prId: data?.prId || fetchedCqData?.prId || "",
        prRef: data?.prRef || fetchedCqData?.prRef || "",
        isRevised: data?.isRevised ?? fetchedCqData?.isRevised ?? false,
      },
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        // email: yup.string().required('Email is required!'),
      }),
      onSubmit: async (value, { resetForm }) => {
      }
    });

  useEffect(() => {
    if (fetchedCqData) {
      if (fetchedCqData.prId) formik.setFieldValue("prId", fetchedCqData.prId);
      if (fetchedCqData.prRef) formik.setFieldValue("prRef", fetchedCqData.prRef);
      if (fetchedCqData.isRevised !== undefined) formik.setFieldValue("isRevised", fetchedCqData.isRevised);
    }
  }, [fetchedCqData]);

  const prIdToUse = formik.values.prId || fetchedCqData?.prId;

  return (
    <div className="w-full h-full py-2 px-2 sm:px-4">
      <div className="flex  justify-between items-start sm:items-center gap-3 mb-3">
        <Breadcrumb
          items={[
            {
              name: "Customer Quotation",
              link: "/sales/quotes",
            },
            {
              name: "Edit Customer Quotation",
            },
          ]}
        />
        <Link
          to={from || "/sales/quotes"}
          state={{
            currentPage: pageIndex,
            searchQuery: searchQuery || "",
          }}
        >
          <BackButton link={true} />
        </Link>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center w-full my-2">
        <NuInputNew
          label="YPR"
          placeholder="Choose"
          formik={formik}
          name="prRef"
          disabled={true}
          width="w-full md:w-1/2 lg:w-1/3"
        />
        {formik.values.isRevised === true && (
          <div className="mt-1 sm:mt-6 flex items-center gap-2">
            <span className="inline-block rounded-full bg-yellow-100 px-3 py-1 text-xs font-semibold text-yellow-800 shadow">
              🔁 Revised
            </span>
          </div>
        )}
      </div>
      <div className="w-full flex items-center gap-4 my-2 border-b border-gray-200 pb-1 overflow-x-auto">
        <Link
          to={`/sales/quotes/edit/${quotesEditId}`}
          state={{
            data: { prId: prIdToUse },
            from: from,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className={`pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary shrink-0 ${`/sales/quotes/edit/${quotesEditId}` == pathFile
            ? "border-b-2 border-baseColor-primary"
            : "border-b-2 border-transparent"
            }`}
        >
          {"Edit Quote"}
        </Link>
        <Link
          to={`/sales/quotes/edit/${quotesEditId}/viewqoute`}
          state={{
            data: { prId: prIdToUse },
            from: from,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className={`pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary shrink-0 ${`/sales/quotes/edit/${quotesEditId}/viewqoute` == pathFile
            ? "border-b-2 border-baseColor-primary"
            : ""
            }`}
        >
          {"Quote Comparison"}
        </Link>
      </div>
      <div className="w-full min-h-[calc(100vh-250px)] ">
        <Outlet context={{ prId: prIdToUse, originalData }} />
      </div>
    </div>
  );
}


export default EditCustomerQuotes;